<template>

  <div id="academy_td">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- academy team development -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">                    
                <div class="row align-items-end">
                  <div class="col-12 order-1 col-md-12 order-md-1 py-3 align-self-start">             
                    <p class="c-txt-orange" style="font-weight: bold;">Maßgeschneiderte Team- & Organisationsentwicklung</p>  
                    <h2 class="text-center text-md-center c-h2" >Individuelle Begleitung für Ihre Organisation</h2>
                  </div>
                  <div class="col-12 order-1 py-1 col-md-12 order-md-1 d-flex align-items-center justify-content-center">             
                    <p class="text-center text-md-left">
                        Nicht jedes Anliegen passt in ein Standard-Format. Ob Veränderungsbegleitung, 
                        Prozessoptimierung oder komplexe Organisationsentwicklung - wir entwickeln gemeinsam mit 
                        Ihnen ein Konzept, das zu Ihrem Team und Ihren Zielen passt.
                    </p>
                  </div>
                  <div class="col-12 order-3 py-1 col-md-7 order-md-2 align-self-start justify-content-center">             
                    <p class="text-center text-md-left" style="font-weight: bold;">Rahmenbedingungen</p>
                    <ul class="text-left">
                      <li>Inhalte, Dauer und Teilnehmendenzahl nach Absprache.</li>
                    </ul>
                    <!-- button -->
                    <div class="d-flex justify-content-left">
                      <a :href="`mailto:info@happinessandwork.de?subject=${emailSubject}&body=${emailBody}`">
                        <div class="c-btn c-btn-orange" >
                          <span style="padding: 10px">Mehr Info & Buchung</span>
                          <div class="c-btn-img c-btn-img-right-white"/>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="col-12 order-2 py-1 col-md-5 order-md-3 d-flex justify-content-center align-self-center">             
                    <!--<img id="bubble_academy_1" src="@/assets/bubble_red_1.png">  -->
                    <img id="bubble_pl" src="@/assets/academy_team_dev.png" alt="HappinessAndWork_Team_Development">  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Academy_TD',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // email data
      emailSubject: "HAW Anfrage - Academy - Individuelle Begleitung für Ihre Organisation",
      emailBody: "Guten Tag,%0A%0Aich bin auf der Website www.happinessandwork.de auf euer Angebot aufmerksam geworden.%0AIch interessiere mich insbesondere für 'Academy - Individuelle Begleitung für Ihre Organisation'.%0AIch würde gern diesbezüglich kontaktiert werden - Tel: [meine_telefonnummer]%0A%0AVielen Dank",
      // metaData
      metaTitle: "- Academy - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/academy/positive_leadership",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes Leadership 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png",
      // eventbride
      eventbriteCourse : [
        //{date: '10. - 12. September 2020', eventId: '116082992355', visible: false},
        //{date: '12. - 14. November 2020', eventId: '116977666349', visible: false},
        //{date: '06. - 08. April 2022', eventId: '165875950433', visible: false},
        //{date: '07. - 09. September 2022', eventId: '168732855513', visible: false},
        {date: 'Kursstart ab  April 2023', eventId: '503552969487', visible: false}
      ],
      eventbriteCourse2 : [
        {date: '14. - 16. September 2023', eventId: '503494163597', visible: false}
      ],
      eventbriteLoaded: false   // status of eventbrite script loading
    }
  },
  // called when component is mounted to the dom
  mounted: function () {
    // load js code from eventbrite
    const eventbriteScript = 'https://www.eventbrite.de/static/widgets/eb_widgets.js'
    this.$loadScript(eventbriteScript)
      .then(() => {
        // Script is loaded
        let eb = {
          // Required
          widgetType: 'checkout',
          eventId: null,
          iframeContainerId: null,
          // Optional
          iframeContainerHeight: 450,  // Widget height in pixels. Defaults to a minimum of 425px if not provided
          onOrderComplete: this.orderCompletedCallback  // Method called when an order has successfully completed
        }
        // prepare iframes for course
        this.eventbriteCourse.forEach((course) => {
          eb.eventId = course.eventId;
          eb.iframeContainerId = 'eventbrite-widget-container-' + course.eventId,
          // create Iframes
          window.EBWidgets.createWidget(eb)
        })
        // prepare iframes for course
        this.eventbriteCourse2.forEach((course) => {
          eb.eventId = course.eventId;
          eb.iframeContainerId = 'eventbrite-widget-container-' + course.eventId,
          // create Iframes
          window.EBWidgets.createWidget(eb)
        })
        // stop spinner
        this.eventbriteLoaded = true
      })
      .catch(() => {
        // Failed to fetch script
        console.log('Failed to load eventbrite script: ' + eventbriteScript); // eslint-disable-line no-console
      });
  },
  methods: {
    /*
    // called when order complete
    orderCompletedCallback() {
      console.log('Order complete!'); // eslint-disable-line no-console
      // send event to analytics
      this.$gtag.event('complete', {
        event_category: 'order',
        event_label: 'Academy',
        value: 123
      })

      this.$ga.event({
        eventCategory: 'order',
        eventAction: 'complete',
        eventLabel: 'Academy',
        eventValue: 123
      })
    }
    */
  }
}

</script>

<style>

</style>
